import React, { useEffect, useState, useRef } from "react"
import * as cookieHelper from "../../helpers/cookie"

export default function NoticeBanner({ noticeBannerText, languageNotAvailable }) {
  const [show, setShow] = useState(false)
  const siteHeaderWrapperRef = useRef(null)

  useEffect(() => {
    siteHeaderWrapperRef.current = document.querySelector(".site-header-wrapper-main")
    if (!cookieHelper.getCookie("MegaMenuSpecialNotice") && languageNotAvailable) {
      if (siteHeaderWrapperRef.current) {
        siteHeaderWrapperRef.current.classList.add("notice-showing")
      }
      setShow(true)
    }
  }, [languageNotAvailable])

  const handleClose = () => {
    cookieHelper.setCookie("MegaMenuSpecialNotice", "closed")
    if (siteHeaderWrapperRef.current) {
      siteHeaderWrapperRef.current.classList.remove("notice-showing")
    }
    setShow(false)
  }

  return (
    <div className="notice-banner" style={{ display: show ? "block" : "none" }}>
      <button className="notice-banner-close" onClick={handleClose}></button>
      <div className="w--wider">
        <p>{noticeBannerText || "*Denne side er kun tilgængelig på engelsk."}</p>
      </div>
    </div>
  )
}
